// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PrivacyPolicy_wrapper__zO3MN","link":"PrivacyPolicy_link__1yurt"};